/* eslint-disable @typescript-eslint/no-redundant-type-constituents */
import classNames from 'classnames';

import Anchor from '~components/Anchor/Anchor';
import { isValidURL } from '~globals/common';

import * as btnStyles from './Button.module.css';

type Props = {
    ['data-planname']?: string;
    ['data-wa-link']?: string;
    btntext?: string;
    className?: string;
    classes?: string;
    disabled?: boolean;
    onClick?: (e: React.MouseEvent) => void;
    styletype?:
        | 'primary'
        | 'secondary'
        | 'secondaryReverse'
        | 'reskin'
        | 'orange'
        | 'link'
        | 'rebrandAction';
    type?: 'button' | 'submit' | 'reset' | undefined;
    target?: string;
    module?: string;
    datawalink?: string | null;
    dataqa?: string | null;
} & (LinkProps | GenericButtonProps);

type LinkProps = {
    islink: true;
} & (
    | {
          forceATag: true;
          href: string;
          to?: never;
      }
    | {
          forceATag?: never;
          href?: never;
          to: string;
      }
);

type GenericButtonProps = {
    islink?: false | never;
    forceATag?: false | never;
    href?: never;
    to?: never;
};

const Button = ({
    btntext,
    children,
    className = '',
    forceATag,
    href = '',
    islink,
    styletype = 'primary',
    to = '',
    datawalink = null,
    dataqa = null,
    ...rest
}: React.PropsWithChildren<Props>) => {
    const islinkRev = (islink && to !== '#') || (!href ? false : islink);
    const dataQAtext = dataqa || datawalink || btntext || 'button';
    const dataQA = dataQAtext.replace(/\s/g, '-');
    const cssClasses = classNames(
        (btnStyles as { [key: string]: string }).btn,
        (btnStyles as { [key: string]: string })[styletype],
        className,
        rest.classes
    );
    // checks if url is absolute or relative
    // if relative, prepend EHI url
    const absURL = (link: string) => {
        switch (true) {
            case /^#/g.test(link):
                return link;
            case isValidURL(link):
                return link;
            default:
                return `${process.env.GATSBY_EHI_URL}${link.replace('/', '')}`;
        }
    };

    // if datawalink (from CRM) is present override the data-wa-link parameter provided
    if (datawalink) rest['data-wa-link'] = datawalink;

    return islinkRev ? (
        forceATag ? (
            <a href={absURL(href)} className={cssClasses} {...rest} data-qa={dataQA}>
                {btntext || children}
            </a>
        ) : (
            <Anchor to={absURL(to)} className={cssClasses} {...rest} data-qa={dataQA}>
                {btntext || children}
            </Anchor>
        )
    ) : (
        <button
            className={cssClasses}
            {...rest}
            onClick={(e) => {
                const { onClick } = rest;
                if (onClick && children === 'Compare plans') {
                    onClick(e);
                }
            }}
            data-qa={dataQA}
        >
            {btntext || children}
        </button>
    );
};

export default Button;
